<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import BrandLogo from "@/components/BrandLogo.vue";
const route = useRoute();
const isOpen = ref(false);
const menuButton = ref<HTMLButtonElement | null>(null);
const activeSection = ref("");
let frame = 0;
function updateActive() {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => {
    if (route.path !== "/") {
      activeSection.value = "";
      return;
    }
    let current = "";
    for (const id of ["products", "technology", "services"]) {
      const section = document.getElementById(id);
      if (section && section.getBoundingClientRect().top <= 180) current = id;
    }
    activeSection.value = current;
  });
}
function escapeMenu() {
  if (isOpen.value) {
    isOpen.value = false;
    menuButton.value?.focus();
  }
}
watch(
  () => route.fullPath,
  () => {
    isOpen.value = false;
    updateActive();
  },
);
onMounted(() => {
  window.addEventListener("scroll", updateActive, { passive: true });
  updateActive();
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", updateActive);
  cancelAnimationFrame(frame);
});
</script>
<template>
  <header class="header" @keydown.esc="escapeMenu">
    <BrandLogo />
    <button
      ref="menuButton"
      class="menu"
      :aria-expanded="isOpen"
      aria-controls="navigation"
      @click="isOpen = !isOpen"
    >
      Menu <span>{{ isOpen ? "−" : "＋" }}</span>
    </button>
    <nav
      id="navigation"
      aria-label="Main navigation"
      :class="{ open: isOpen }"
      @click="isOpen = false"
    >
      <RouterLink
        to="/#products"
        :aria-current="activeSection === 'products' ? 'location' : undefined"
        >Products</RouterLink
      >
      <RouterLink
        to="/#technology"
        :aria-current="activeSection === 'technology' ? 'location' : undefined"
        >Equipment &amp; technology</RouterLink
      >
      <RouterLink
        to="/#services"
        :aria-current="activeSection === 'services' ? 'location' : undefined"
        >Drilling &amp; blasting</RouterLink
      >
      <RouterLink class="nav-end" to="/contact"
        >Contact us <span aria-hidden="true">↗</span></RouterLink
      >
    </nav>
  </header>
</template>
